import React from 'react';
import Logo from '../components/Logo';
import './About.css';

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <div className="about-logo">
              <Logo width={120} height={120} className="about-logo-svg" />
            </div>
            <h1>About The MINT School</h1>
            <p className="hero-subtitle">Building A Solid Foundation Since Our Inception</p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <div className="card-icon">🎯</div>
              <h2>Our Mission</h2>
              <p>
                To provide quality education that empowers students with knowledge, 
                skills, and values necessary for success in a rapidly changing world. 
                We are committed to nurturing critical thinking, creativity, and 
                character development in every student.
              </p>
            </div>
            <div className="vision-card">
              <div className="card-icon">👁️</div>
              <h2>Our Vision</h2>
              <p>
                To be a leading educational institution that produces well-rounded, 
                innovative, and responsible citizens who contribute positively to 
                society and excel in their chosen fields of endeavor.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="our-story">
        <div className="container">
          <div className="story-content">
            <h2>Our Story</h2>
            <div className="story-text">
              <p>
                The MINT School was established with a clear vision to provide 
                exceptional education in Asa-Otukpo, Benue State. Our name "MINT" 
                represents our core values: <strong>M</strong>otivation, 
                <strong>I</strong>ntegrity, <strong>N</strong>urturing, and 
                <strong>T</strong>ransformation.
              </p>
              <p>
                Since our founding, we have been committed to creating an environment 
                where students can thrive academically, socially, and personally. 
                Our dedicated faculty and staff work tirelessly to ensure that each 
                student receives the attention and support they need to reach their 
                full potential.
              </p>
              <p>
                We believe that education is not just about academic achievement, 
                but about developing the whole person. Our holistic approach to 
                education ensures that students graduate not only with excellent 
                academic credentials but also with strong character, leadership 
                skills, and a commitment to making a positive difference in the world.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="values">
        <div className="container">
          <h2>Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">💪</div>
              <h3>Motivation</h3>
              <p>Inspiring students to pursue excellence and reach their highest potential through encouragement and positive reinforcement.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Integrity</h3>
              <p>Upholding the highest standards of honesty, fairness, and ethical behavior in all our interactions and practices.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🌱</div>
              <h3>Nurturing</h3>
              <p>Providing a supportive and caring environment that fosters growth, development, and well-being of every student.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🔄</div>
              <h3>Transformation</h3>
              <p>Empowering students to transform their lives and communities through education, innovation, and positive change.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="leadership">
        <div className="container">
          <h2>Our Leadership Team</h2>
          <div className="leadership-grid">
            <div className="leader-card">
              <div className="leader-avatar">👨‍💼</div>
              <h3>Principal</h3>
              <h4>Dr. [Name]</h4>
              <p>Leading our school with vision and dedication, ensuring academic excellence and student success.</p>
            </div>
            <div className="leader-card">
              <div className="leader-avatar">👩‍🏫</div>
              <h3>Vice Principal</h3>
              <h4>Mrs. [Name]</h4>
              <p>Supporting our educational mission and fostering a positive learning environment for all students.</p>
            </div>
            <div className="leader-card">
              <div className="leader-avatar">👨‍🎓</div>
              <h3>Academic Director</h3>
              <h4>Mr. [Name]</h4>
              <p>Overseeing curriculum development and ensuring the highest standards of academic delivery.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="statistics">
        <div className="container">
          <h2>School Statistics</h2>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">500+</div>
              <div className="stat-label">Students</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">25+</div>
              <div className="stat-label">Teachers</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">15+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">95%</div>
              <div className="stat-label">Success Rate</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
